<template>
  <nav class="Menu">

    <router-link class="Menu-item"
      v-for="(item, index) in global.menu"
      :key="'menuItem' + index"
      :to="{ path: item.path }">
      {{ item.title }}
    </router-link>

  </nav>
</template>

<script>
export default {}
</script>

<style>
@import 'properties';

.Menu {
  user-select: none;
}

.Menu-item {
  display: block;
  font-size: 36px;
  line-height: 1;
  font-weight: 200;
  text-decoration: none;
  color: var(--c-grey-xlt) !important;
  text-align: right;
  padding: var(--unit-05) 0;

  @media (min-width: 600px) {
    display: inline-block;
    padding: 0;
    font-size: 13px;
    font-weight: 400;
  }

  @media (min-width: 680px) {
    font-size: 15px;
  }
}

.Menu-item:hover,
.Menu-item.router-link-active {
  color: var(--c-white) !important;
}

.Menu-item + .Menu-item {
  margin-left: var(--unit);

  @media (min-width: 760px) {
    margin-left: var(--unit-2);
  }
}
</style>



// WEBPACK FOOTER //
// MenuComponent.vue?4e268c94